<form [formGroup]="payHistory">
    <div class="card-body pb-0 spacing" #contentToConvert>
        <div class="receipt ">
            <div class="row ">
                <!-- <div class="col-sm-12"> -->
                    <div class="col-sm-3">
                        <img src="../../assets/images/logo-light.png" class="header-brand-img reciptLogo desktop-logo" alt="logo">
                    </div>
                    <div class="col-sm-9">
                        <h3 class="mra">{{InstuName}}</h3>
                        <h6 class="mra11">(A State University of the Govt. of Assam)</h6>
                        <h6 class="mra1">{{ FeeType || 'Payment Receipt' }}</h6>
                        <h6 class="addc">Address: 2nd Floor, Gauhati Medical College Building, Narkashur Hilltop, Bhangagarh, Guwahati-781032,Assam</h6>
                        <h6 class="addc">Tel:6026177313 | Email:ssuhs_assam@yahoo.in | Web: http://www.ssuhs.in/    GST No. : 18SHLS03712C1DR</h6>
                   
                    </div>
                    <!-- </div> -->
            </div>
            <div class="row">
                <div class="receipt-details">
                    <div class="row">
                        <div class="col-sm-6">
                            <p><strong>Receipt Number:</strong> {{reciptNumber}}</p>
                        </div>
                        <div class="col-sm-6">
                            <p><strong>Receipt Date:</strong> {{currentDate | date: 'dd/MM/yyyy'}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <p><strong>College:</strong> {{clgName}} <span id="college"></span></p>
                        </div>
                        <div class="col-sm-6">
                            <p><strong>Course:</strong> {{CoName}} <span id="program"></span></p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6" >
                            <p><strong>Rg No:</strong>{{studentPrn}}</p>
                        </div>
                        <!-- <div class="col-sm-6" *ngIf="PreFix == '' ">
                            <p><strong>Rg No/PRN No.:</strong>{{formattedPrn}}</p>
                        </div> -->
                        <div class="col-sm-6">
                            <p><strong>Student Name:</strong> {{FullName}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <p><strong>Father Name:</strong>{{FatherName}}</p>
                        </div>
                        <div class="col-sm-6">
                            <p><strong>Mother Name:</strong>{{MotherName}} </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <p><strong>Mobile No.:</strong>{{mobileNo}}</p>
                        </div>
                        <div *ngIf="DateOfBirth" class="col-sm-6">
                            <p><strong>DOB:</strong>{{stuDOB | date: 'dd/MM/yyyy'}} </p>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!Transcript" class="mt-2">
                <table class="styled-table" style="width:100%">
                    <thead>
                        <tr >
                            <th width="40%" class="f600 text-center">Fee Head</th>
                            <th width="20%" class="f600 text-center">Fee Paid</th>
                            <th width="20%" class="f600 text-center">Transaction Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr  *ngFor="let item of payHistoryData; let i = index">
                            <td class="text-center">{{item.Head != null ? item.Head : item.FeeHead}}</td>
                            <td class="text-center" *ngIf="Currency == 'INR' ">
                                <span class="currency-symbol Textmrg1">&#8377;{{item.FeeAmt}}</span>
                            </td>
                            <td class="text-center" *ngIf="Currency == 'USD' ">
                                <span class="currency-symbol Textmrg1">&#8377;{{item.FeeAmt}}</span>
                            </td>
                            <td class="text-center">{{item.FeePaymentDate | date: 'dd/MM/yyyy'}}</td>
                       </tr>
                    </tbody>
                </table>
            </div>
            <div *ngIf="Transcript && TranscriptData.CertStatus === 'Submitted'" class="mt-2">
                <table class="styled-table" style="width:100%">
                    <thead>
                        <tr >
                            <th width="40%" class="f600">Fee Head</th>
                            <th width="20%" class="f600">Fee Paid</th>
                            <th width="20%" class="f600"> Transaction Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr 
                          *ngFor="let item of payHistoryData; let i = index"
                          [class.subhead]="isSubhead(item.FeeHead)"
                          [class.head]="isHead(item.FeeHead)">
                          <td [class.indented]="isSubhead(item.FeeHead)">
                            {{item.Head != null ? item.Head : item.FeeHead}}
                          </td>
                          <td class="tae" *ngIf="Currency === 'INR'">
                            <span class="currency-symbol Textmrg1">&#8377;{{item.FeeAmt}}</span>
                          </td>
                          <td class="tae" *ngIf="Currency === 'USD'">
                            <span class="currency-symbol Textmrg1">&#8377;{{item.FeeAmt}}</span>
                          </td>
                          <td>{{item.FeePaymentDate | date: 'dd/MM/yyyy'}}</td>
                        </tr>
                      </tbody>

                </table>
                <ul>
                    <li >Additional Set : {{TranscriptData.StuCertCopies}}</li>
                    <li >Delivery Option : {{TranscriptData.DeliveryOpt == 'Hard' ? 'Hard Copy' : (TranscriptData.DeliveryOpt == 'Soft' ? 'Soft Copy' : 'Hard Copy and Soft Copy')}}</li>
                </ul>
                
                <ul>Extra Charges: 
                    <li>1650/- per additional set for transcript.</li>
                    <li>750/- per additional set for postal charge(Hard Copy).</li>
                </ul>
            </div>

            <div class="row">
                <div class="receipt-footer">
                    <div class="row mt-2">
                        <div class="col-sm-6" *ngIf="Currency == 'INR' ">
                            <b>Total Paid Amount: </b>
                            <span class="currency-symbol Textmrg1">&#8377;{{TotalPaidAmount}}</span>
                        </div>
                        <div class="col-sm-6" *ngIf="Currency == 'USD' ">
                            <b>Total Paid Amount:</b>
                            <span class="currency-symbol Textmrg1"> &#8377;{{TotalPaidAmount}}</span>
                        </div>
                        <div class="col-sm-6" *ngIf="Currency == 'INR' ">
                            <b>In Words: </b>
                            <span class="currency-symbol Textmrg1 linkk">Rupees {{TotalPaidAmountInWords}} Only</span>
                        </div>
                        <div class="col-sm-6" *ngIf="Currency == 'USD' ">
                            <b>In Words: </b>
                            <span class="currency-symbol Textmrg1 linkk">Rupees {{TotalPaidAmountInWords}} Only</span>
                        </div>
                      
                    </div>

                    <div class="row mt-2">
                        <div class="col-sm-6">
                            <b>Transaction Ref. No.:</b>
                            <span class=" Textmrg1"> {{TransactionNo}}</span>
                        </div>
                        <div class="col-sm-6">
                            <b>Payment Mode:</b>
                            <span class=" Textmrg1"> {{payModeee}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row col-sm-12 mb-2 mt-2">
            <div class="col-sm-2 divName offset-8">
                <button type="button" class="btn no-print fr sz btn-primary btn-icon-text floatright mt-1 fr"
                    (click)="close()">
                    <span style="display: contents; align-items: center;">
                        Close
                    </span>
                </button>
            </div>
            <div class="col-sm-2 divName">
                <button type="button" class="btn no-print fr sz btn-primary btn-icon-text floatright mt-1 fr"
                    (click)="downloadAsPDF()">
                    <span style="display: contents; align-items: center;">
                        Download
                     </span>
                </button>
            </div>
        </div>
    </div>
</form>